import React, { memo, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Form, Field, SubmitButton } from '@bottomless/common/components';
import { useQueryString } from '@bottomless/common/hooks';
import { submitByoProductAction } from '../../../../store/byo';
import { useCallback } from 'react';
import { ChevronLeft } from 'react-feather';

const schema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address.')
    .required('Email is required.'),
  description: Yup.string().required('Product URL or description is required.'),
});

const defaultValues = {
  email: '',
  description: '',
};

const ProductFormComponent = ({ submitByoProduct }) => {
  const { params: queryParams } = useQueryString();
  const [isFinished, setIsFinished] = useState(false);

  const onSuccess = useCallback(
    (_, { resetForm }) => {
      resetForm(defaultValues);
      setIsFinished(true);
    },
    [setIsFinished]
  );

  return (
    <div className="product-form w-form">
      <Form
        className="form"
        initialValues={defaultValues}
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={submitByoProduct}
        onSuccess={onSuccess}
      >
        {({ isSubmitting }) => (
          <>
            <Field name="email" type="email" placeholder="E-mail address" maxLength="256" size="lg" />
            <Field name="description" placeholder="Product URL or description" size="lg" />
            <div className="d-flex justify-content-center">
              <SubmitButton color="accent" isSubmitting={isSubmitting} loadingText="Submitting" size="lg">
                Submit
              </SubmitButton>
            </div>
          </>
        )}
      </Form>
      {isFinished && (
        <div className="text-accent text-center mt-4">
          <div>Thank you for filling out the information! Our team will get back to you shortly with more details.</div>
          {queryParams.back && (
            <a href={queryParams.back} title="Back" className="product-form-back mt-3">
              <ChevronLeft size="18" /> Back
            </a>
          )}
        </div>
      )}
    </div>
  );
};

ProductFormComponent.propTypes = {
  submitByoProduct: PropTypes.func.isRequired,
};

export const ProductForm = connect(null, dispatch => ({
  submitByoProduct: data => dispatch(submitByoProductAction(data)),
}))(memo(ProductFormComponent));
